import { useStrictLocalization } from "@faire/web/common/localization";
export var useLoggedOutBrandNodes = function useLoggedOutBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var loggedOutBrandNodes = {
    L1: {
      Account: strictLocalize({
        id: "7flPEZ",
        defaultMessage: "Account settings (e.g. update email, bank info)"
      }),
      Catalog: strictLocalize({
        id: "PewJ+O",
        defaultMessage: "Catalog and shop information"
      }),
      Disputes: strictLocalize({
        id: "Sb6ix0",
        defaultMessage: "Disputes"
      }),
      Invoices: strictLocalize({
        id: "t1H2TU",
        defaultMessage: "Invoices and payments"
      }),
      Orders: strictLocalize({
        id: "lour39",
        defaultMessage: "Orders and fulfillment"
      }),
      UpdateCommission: strictLocalize({
        id: "9/FL8z",
        defaultMessage: "Update commission / relationship"
      }),
      GeneralShipping: strictLocalize({
        id: "ueCCEa",
        defaultMessage: "General shipping questions"
      }),
      Other: strictLocalize({
        id: "anUKfs",
        defaultMessage: "Other Brand Issues"
      })
    },
    L2: {
      SWF: strictLocalize({
        id: "xc/zXa",
        defaultMessage: "Ship with Faire"
      }),
      SOYO: strictLocalize({
        id: "R22FJg",
        defaultMessage: "Ship on your own"
      }),
      SellingInternational: strictLocalize({
        id: "vNJE8v",
        defaultMessage: "Selling International"
      }),
      Other: strictLocalize({
        id: "+c3AoM",
        defaultMessage: "Other questions"
      })
    },
    L3: {
      Availability: strictLocalize({
        id: "UaBkUO",
        defaultMessage: "Is ship with Faire available in my country?"
      }),
      LabelIssues: strictLocalize({
        id: "1HdGkw",
        defaultMessage: "Label issues"
      }),
      Costs: strictLocalize({
        id: "oQXdAP",
        defaultMessage: "Costs"
      }),
      Others: strictLocalize({
        id: "IwX/dA",
        defaultMessage: "Others"
      }),
      HowTo: strictLocalize({
        id: "ayEfYp",
        defaultMessage: "How to?"
      })
    }
  };
  return loggedOutBrandNodes;
};